import officeElegance from '@/assets/img/users-cases/office-elegance.webp';
import officeEleganceHow from '@/assets/img/users-cases/office-elegance-how.webp';
import officeEleganceResult from '@/assets/img/users-cases/office-elegance-result.webp';

export default {
  slug: '360-tour-office-lux ',
  order: 2,
  title: '360 Tour Office lux ',
  subtitle: 'Premium office renderings with realistic 3D visuals',
  tags: ['Officefloorplans', 'Officelayouts'],

  images: {
    hero: officeElegance,
    aboutTop: officeEleganceHow,
    aboutBottom: officeEleganceResult,
  },

  howText:
    'Created 2D and 3D office floor plans for open-space areas, private offices, meeting rooms, and executive suites. The design includes premium furniture, lighting, and materials to visually communicate value and style.',

  resultText:
    'Developers can immediately use the plans in presentations, marketing materials, and investor approvals, accelerating sales of commercial office spaces and increasing client confidence.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: ['office-dark', 'office-standard'],
};
